// ===== EARTH, ENVIRONMENT & OCEAN =====
const EARTH_ENV = [
  {
    id: "bsc-geology",
    name: "B.Sc in Geology",
    stream: "science",
    category: "earth-env",
    summary:
      "Study of Earth's structure, minerals, rocks, earthquakes, and natural resources management.",
    eligibility: "10+2 with PCM/PCB; entrance via CUET UG or state-level university exams.",
    exams: ["CUET UG", "State CETs"],
    colleges: [
      "IIT Roorkee",
      "University of Delhi",
      "Banaras Hindu University (BHU)",
      "Indian School of Mines (ISM) Dhanbad",
      "University of Calcutta"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["rocks", "minerals", "earth", "geophysics"],
  },
  {
    id: "bsc-geophysics",
    name: "B.Sc in Geophysics",
    stream: "science",
    category: "earth-env",
    summary:
      "Application of physics to study Earth: seismic, gravity, magnetic & environmental studies.",
    eligibility: "10+2 with PCM; entrance via CUET UG or university-level tests.",
    exams: ["CUET UG", "State CETs"],
    colleges: [
      "IIT Kharagpur",
      "IIT Roorkee",
      "Banaras Hindu University (BHU)",
      "University of Delhi"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["seismic", "gravity", "magnetics", "Earth studies"],
  },
  {
    id: "bsc-environmental-science",
    name: "B.Sc in Environmental Science",
    stream: "science",
    category: "earth-env",
    summary:
      "Study of ecosystems, pollution control, sustainability, climate change, and resource management.",
    eligibility: "10+2 with PCB/PCM; CUET UG or state/university entrance exams.",
    exams: ["CUET UG", "State CETs"],
    colleges: [
      "Jawaharlal Nehru University (JNU)",
      "University of Delhi",
      "Banaras Hindu University (BHU)",
      "IIT Bombay",
      "IIT Roorkee"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["ecology", "sustainability", "climate", "pollution"],
  },
  {
    id: "bsc-oceanography",
    name: "B.Sc in Oceanography / Marine Sciences",
    stream: "science",
    category: "earth-env",
    summary:
      "Study of oceans: marine biology, chemistry, physics, geology, coastal & marine resource management.",
    eligibility: "10+2 with PCB/PCM; entrance via CUET UG or university-level exams.",
    exams: ["CUET UG", "State CETs"],
    colleges: [
      "IIT Madras – Ocean Engineering",
      "CUSAT – Cochin University",
      "Goa University",
      "University of Mumbai – Marine Science",
      "Andhra University – Marine Sciences"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["oceans", "marine biology", "coastal", "environment"],
  },
  {
    id: "bsc-geography",
    name: "B.Sc in Geography",
    stream: "science",
    category: "earth-env",
    summary:
      "Spatial study of Earth's surface, GIS, remote sensing, climatology, urban planning, and resources.",
    eligibility: "10+2 with PCM/PCB/Arts; entrance via CUET UG or state university exams.",
    exams: ["CUET UG", "State CETs"],
    colleges: [
      "University of Delhi",
      "Banaras Hindu University (BHU)",
      "Jamia Millia Islamia",
      "Jawaharlal Nehru University (JNU)",
      "University of Calcutta"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["GIS", "remote sensing", "climate", "urban planning"],
  },
  {
    id: "btech-ocean-engineering",
    name: "B.Tech in Ocean Engineering / Naval Architecture",
    stream: "science",
    category: "earth-env",
    summary:
      "Design, construction, and operation of ships, offshore structures, and ocean technologies.",
    eligibility: "10+2 with PCM; entrance via JEE Main, JEE Advanced, or state CETs.",
    exams: ["JEE Main", "JEE Advanced", "State CETs"],
    colleges: [
      "IIT Madras",
      "Indian Maritime University (IMU) Chennai",
      "Cochin University of Science & Technology (CUSAT)",
      "MERI Kolkata"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["ships", "naval", "ocean", "structures"],
  },
  {
    id: "bsc-climate-science",
    name: "B.Sc in Climate Science / Meteorology",
    stream: "science",
    category: "earth-env",
    summary:
      "Study of atmospheric processes, weather forecasting, climate change, and environmental monitoring.",
    eligibility: "10+2 with PCM/PCB; entrance via CUET UG or state/university exams.",
    exams: ["CUET UG", "State CETs"],
    colleges: [
      "IIT Delhi – Climate Studies",
      "IIT Roorkee",
      "Indian Institute of Tropical Meteorology, Pune",
      "Banaras Hindu University (BHU)"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["weather", "climate", "atmosphere", "forecasting"],
  },
];

export default EARTH_ENV;
